import { SetStateAction, createContext } from 'react';

export interface ScrollSection {
  label: string;
  id: string;
  /**
   * The DOM element to scroll to. Is undefined/null on SSR.
   */
  element: HTMLElement | null | undefined;
}

/**
 * Determines whether the passed-in `subject` correctly implements the `ScrollSection` interface.
 *
 * @typeguard
 */
export const isScrollSection = (subject: unknown): subject is ScrollSection => {
  return (
    typeof subject === 'object' &&
    subject !== null &&
    'element' in subject &&
    subject.element instanceof HTMLElement &&
    'id' in subject &&
    typeof subject.id === 'string' &&
    subject.id.length > 0 &&
    'label' in subject &&
    typeof subject.label === 'string' &&
    subject.label.length > 0
  );
};

export interface ScrollContextType {
  headerIsVisible: boolean;
  setHeaderIsVisible: (newState: SetStateAction<boolean>) => void;
  hasPageNavigation: boolean;
  setHasPageNavigation: (newState: SetStateAction<boolean>) => void;
  lastScrollSectionChange: number;
  setLastScrollSectionChange: (newState: SetStateAction<number>) => void;
  localeSwitchBannerIsVisible: boolean;
  setLocaleSwitchBannerIsVisible: (newState: SetStateAction<boolean>) => void;
}

export const ScrollContext = createContext<ScrollContextType>({
  headerIsVisible: false,
  setHeaderIsVisible: (newState: SetStateAction<boolean>) => {
    return;
  },
  hasPageNavigation: false,
  setHasPageNavigation: (newState: SetStateAction<boolean>) => {
    return;
  },
  lastScrollSectionChange: 0,
  setLastScrollSectionChange: (newState: SetStateAction<number>) => {
    return;
  },
  localeSwitchBannerIsVisible: false,
  setLocaleSwitchBannerIsVisible: (newState: SetStateAction<boolean>) => {
    return;
  },
});
